<ngb-pagination
    [(page)]="page"
    [collectionSize]="size"
    [pageSize]="perPage"
    (pageChange)="onChange.emit($event)"
    class="d-flex justify-content-center"
>
</ngb-pagination>
